<template>
    <form v-bind="$attrs" @submit="submit" @reset="reset">
        <slot></slot>
    </form>
</template>

<script>
export default {
    props: {
        onSubmit: Function,
        onReset: Function
    },
    methods: {
        submit(e) {
            e.preventDefault()
            const invalidInput = this.validateInputs(e)
            if(invalidInput || e.target.checkValidity() === false) {
                e.stopPropagation()
                invalidInput && invalidInput.focus()
                return
            }
            this.onSubmit && this.onSubmit(e)
        },
        reset(e) {
            const reset = new Event('reset-input')
            for (let input of e.target.querySelectorAll('.form-control.validation-input')) {
                input.dispatchEvent(reset)
            }
            this.onReset && this.onReset(e)
        },
        validateInputs(e) {
            let invalid = null
            const validate = new Event('validate-input')
            for (let input of e.target.querySelectorAll('.form-control.validation-input')) {
                input.dispatchEvent(validate)
                if(input.getAttribute('is-invalid') === 'true') {
                    invalid = input
                }
            }
            return invalid
        }
    }
}
</script>